import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get item
export const getItem = createAsyncThunk("item/getItem", async (postsPerPage, { rejectWithValue }) => {
  try {
    const { data } = await API.getItem(postsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});

// get all item
export const getAllItem = createAsyncThunk("item/getAllItem", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllItem();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});

// get previous
export const getPrevious = createAsyncThunk("item/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});
// get next
export const getNext = createAsyncThunk("item/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});

// get particular page
export const getPageItem = createAsyncThunk("item/getPageItem", async (data, { rejectWithValue }) => {
  const { number, postsPerPage } = data;
  try {
    const { data } = await API.getPageItem(number, postsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});

// create item
export const createItem = createAsyncThunk("item/createItem", async (data, { rejectWithValue }) => {
  const { name, code, rate, materialType, yarnQuality, description, active } = data;
  try {
    const body = JSON.stringify({
      name,
      code,
      rate,
      materialType,
      yarnQuality,

      description,
      active,
    });
    const { data } = await API.createItem(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});
export const updateItem = createAsyncThunk("item/updateItem", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const { name, code, rate, yarnType, materialType, itemType, yarnQuality, description, active } = values;
  try {
    const body = JSON.stringify({
      name,
      code,
      rate,
      yarnType,
      materialType,
      yarnQuality,
      itemType,
      description,
      active,
    });
    const { data } = await API.updateItem(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});

// handle search
export const handleSearch = createAsyncThunk("item/handleSearch", async (data, { rejectWithValue }) => {
  const { search, postsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, postsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.errors[0]?.error);
  }
});
